import useClients from "./clients";
import useCertificates from "./certificates";
import useConcretings from "./concretings";
import useConcretingRequests from "./concretingRequests";
import useContracts from "./contracts";
import useInvoices from "./invoices";
import useUsers from "./users";
import usePermissionsUsers, { ContractPermissions } from "./permissionsUsers";

export type { ContractPermissions };

export default {
  useClients,
  useCertificates,
  useConcretings,
  useConcretingRequests,
  useContracts,
  useInvoices,
  useUsers,
  usePermissionsUsers
};
